import { getThemeDataMapKey } from '../utils/getThemeDataMapKey';
import { store } from '../store/store';
import type { ThemeResources } from '../schema/ThemeResources';

/**
 * Return the theme resources for the given theme
 * @param themeId Theme to get values for. If not provided, defaults to the current theme.
 * @param isDarkTheme If not provided, defaults to the a value based on current theme mode.
 */
export const getResourcesForTheme = (themeId?: string, isDarkTheme?: boolean): ThemeResources => {
    const themeDataMapKey = getThemeDataMapKey(themeId, isDarkTheme);
    return store.themeData.get(themeDataMapKey);
};
